export default {
	/**
	 * CSS class used for active category
	 * @const
	 * @type {string}
	 * @default
	 */
	ACTIVE_CLASS: 'active',
	/**
	 * Is the CategoryAssets class extended from the MiniAssets class (instead of the Assets class)?
	 * @const
	 * @type {boolean}
	 * @default
	 */
	ASSETS_MINI: false,
	/**
	 * CSS class used for open tree nodes
	 * @const
	 * @type {string}
	 * @default
	 */
	TREE_NODE_OPEN_CLASS: 'open',
	/**
	 * CSS class used for closed tree nodes
	 * @const
	 * @type {string}
	 * @default
	 */
	TREE_NODE_CLOSED_CLASS: 'closed',
	/**
	 * CSS id used for the container element
	 * @const
	 * @type {string}
	 * @default
	 */
	TREE_ID: 'category-tree',
	/**
	 * CSS id used for the category layer header
	 * @const
	 * @type {string}
	 * @default
	 */
	CATEGORY_HEADER_ID: 'category-header',
	/**
	 * CSS id used for the category list container element
	 * @const
	 * @type {string}
	 * @default
	 */
	CATEGORY_LIST_ID: 'category-list',
	/**
	 * CSS id used for the category asset list container element
	 * @const
	 * @type {string}
	 * @default
	 */
	ASSET_LIST_ID: 'category-assets',
	/**
	 * Should the asset list employ faceted search?
	 * @const
	 * @type {string}
	 * @default
	 */
	ASSET_LIST_FACETED: false,
	/**
	 * CSS id used for the breadcrumb container element
	 * @const
	 * @type {string}
	 * @default
	 */
	BREADCRUMB_ID: 'breadcrumb',
	/**
	 * CSS id used for the category detail container element
	 * @const
	 * @type {string}
	 * @default
	 */
	CATEGORY_DETAIL_ID: 'category',
	/**
	 * CSS id of the category container element
	 * @const
	 * @type {string}
	 * @default
	 */
	CONTAINER_ID: 'categories',
	/**
	 * CSS id for the category edit container element
	 * @const
	 * @type {string}
	 * @default
	 */
	CATEGORY_EDIT_ID: 'category-edit',
	/**
	 * Should we allow drag actions on categories?
	 * @const
	 * @type {boolean}
	 * @default
	 */
	DRAGGABLE: true,
	/**
	 * Category edit view display type
	 * @const
	 * @type {boolean}
	 * @default
	 */
	MODAL: true,
	/**
	 * Default category id
	 * @const
	 * @type {number}
	 * @default
	 */
	categoryid: 1,
	/**
	 * Allows categories to be only displayed in the tree or both the tree and gallery
	 * @const
	 * @type {boolean}
	 * @default
	 */
	displayCategoriesAsAssets: true,
	/**
	 * Default repository directory path
	 * @const
	 * @type {string}
	 * @default
	 */
	repositorydirectory: '/',
	/**
	 * Turns the category tree on or off
	 * @const
	 * @type {boolean}
	 * @default
	 */
	tree: true,
	/**
	 * Sets the maximum depth to display in the category tree
	 * @const
	 * @type {string}
	 * @default
	 */
	TREE_MAX_DEPTH: null, // How many layers deep should we display?
};
